import * as React from 'react';
import {useFormikContext} from 'formik';
import styled from 'styled-components';
import InputRange from 'components/InputRange';
import {ChangeEvent} from "react";
import {TariffsValues} from "../types";
import {getDiscount, getPaymentPeriodValue} from "./Constructor";

const Container = styled.div`
  display: grid;
  gap: 10px;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.01em;
`;

const Footer = styled(Header)``;

/**
 * render tariffs storage range component
 * @constructor
 */
export default function RangeStorage(): React.ReactElement {
  const min = 5;
  const max = 5000;

  const {values, setFieldValue} = useFormikContext<Partial<TariffsValues>>();

  /**
   * range change handler
   * @param {ChangeEvent<HTMLInputElement>} event
   * @constructor
   */
  function rangeChangeHandler(event: ChangeEvent<HTMLInputElement>) {
    const value = Number(event.target.value);
    setFieldValue('selected.storage', value);
    value === min
      ? setFieldValue('selected.prices.storage', 0)
      : setFieldValue('selected.prices.storage', value * 3);
  }

  /**
   * render storage cost value
   * @constructor
   */
  function renderCost() {
    const period = values?.selected?.paymentPeriod;
    const price = values?.selected?.prices?.storage || 0;

    const discount = price * getDiscount(period) / 100;
    const value = (price - discount) * getPaymentPeriodValue(period);

    const text = value
      ? Math.round(value) + ' ₽'
      : 'Бесплатно'

    return (
      <span>{text}</span>
    )
  }

  return (
    <Container>
      <Header>
        <span>{min} ГБ</span>
        <span>{values?.selected?.storage} гб</span>
        <span>5 ТБ</span>
      </Header>
      <InputRange
        min={min}
        max={max}
        step={5}
        defaultValue={values?.selected?.storage}
        onChange={rangeChangeHandler}
      />
      <Footer>
        {renderCost()}
        <span>{max * 3} ₽</span>
      </Footer>
    </Container>
  );
}
